// Module
var code = "<header> <div class=\"heading\"> <h2>Style</h2> </div> </header> <div class=\"modal-body\"> <div class=\"inner\"></div> </div> <footer> <div class=\"controls\"> <a class=\"submit btn-flat\" href=\"#\"> Cancel </a> </div> </footer> ";
// Exports
export default code;